import React from "react";
import content from 'content.json';
import { Card, CardBody, Row, Col } from "reactstrap";

function Cookies() {
  return (
    <div className="content">
      <Row>
        <Col md="10">
          <Card>
            <CardBody>
              <div style={{ padding: '16px 8px' }}>
                <h1 style={{ fontSize: '1.8rem', marginBottom: '8px' }}>
                  <i className="fas fa-cookie-bite" style={{ color: 'var(--airiq-teal)', marginRight: '12px' }}></i>
                  Cookie Policy
                </h1>
                
                <p style={{ marginBottom: '24px' }}>
                  At {content.brandname}, we do not use marketing or analytics cookies. 
                  However, we do use a functional cookie to enhance your experience.
                </p>

                <div style={{ 
                  background: 'rgba(0, 212, 170, 0.06)', border: '1px solid rgba(0, 212, 170, 0.15)',
                  borderRadius: '12px', padding: '20px 24px', marginBottom: '24px'
                }}>
                  <h3 style={{ fontSize: '1rem', marginBottom: '12px' }}>
                    <i className="fas fa-info-circle" style={{ color: 'var(--airiq-teal)', marginRight: '8px' }}></i>
                    Functional Cookie
                  </h3>
                  <p style={{ margin: 0, fontSize: '0.9rem' }}>
                    This cookie stores your encrypted session sign-in/login token for a duration of 
                    <strong style={{ color: 'var(--airiq-teal)' }}> 3 hours</strong>, ensuring that you do not have to sign in with 
                    Google every time you visit the page within this period.
                  </p>
                </div>

                <p>
                  By using the website, and specifically when you use the functionality "View Your {content.entries}" 
                  by signing in with Google, you agree to the use of this functional cookie. This cookie is 
                  essential for the functionality of the website and automatically becomes invalid after 3 hours.
                </p>

                <p>
                  For more information on how we handle your data, please review our{' '}
                  <a href="#/admin/Privacy">Privacy Policy</a>.
                </p>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export default Cookies;
